import { safeJSONParse } from '../utils/safeJSONParse.js';

let clientStateCallbacks = [];
window.onClientStateChange = (text) => {
    const payload = safeJSONParse(text);
    clientStateCallbacks.forEach((callback) => {
        callback(payload);
    });
};
function onClientStateChange(callback) {
    clientStateCallbacks.push(callback);
}

export { onClientStateChange };
//# sourceMappingURL=onClientStateChange.js.map
